import { useState } from 'react';
import { DataGrid } from '../../components/grid/DataGrid';
import { SchedaOrdine } from './SchedaOrdine';

const INTESTAZIONI: Record<string, string> = {
  DataOrdine: 'Del',
  ConsegnaRichiesta: 'Chiesta per',
  ConsegnaConfermata: 'Confermata per',
  RiferimentoFornitore: 'Suo rif.',
  ConNonConformita: 'Respinte',
};

/*  LE COLONNE A PASTIGLIA, dal 20/09/2026.

    «Consegna» e' la colonna che dice se e' tutto arrivato, ed e' la ragione per cui si
    apre questa schermata: in testo grigio alto dodici pixel, su venticinque righe, non si
    distingueva da un nome di fornitore. Stesso verde e stessa ambra della scheda di
    commessa, che porta gli stessi stati — punto 8 della riunione del 14/09.  */
const PASTIGLIE = ['Stato', 'Consegna'];

export function ElencoOrdini() {
  const [aperto, setAperto] = useState<string | null>(null);
  const [versione, setVersione] = useState(0);

  return (
    <section className="pagina con-scheda">
      <div className="colonna-principale">
        <header className="testata-pagina">
          <div>
            <h1>Ordini fornitore</h1>
            <p>
              Gli ordini emessi, dal più recente. Apri una riga per inviarlo, registrare la
              conferma del fornitore o segnare una bolla di consegna. La colonna «consegna»
              dice se è tutto arrivato, e «in ritardo» guarda la data che il fornitore ha
              confermato — non quella che gli abbiamo chiesto.
            </p>
          </div>
        </header>

        <DataGrid
          nomeGriglia="ordini"
          versione={versione}
          colonneVisibili={[
            'Numero',
            'Sede',
            'Stato',
            'Fornitore',
            'Consegna',
            'InRitardo',
            'ConNonConformita',
            'DataOrdine',
            'ConsegnaRichiesta',
            'ConsegnaConfermata',
            'Confermato',
            'RiferimentoFornitore',
            'Commesse',
            'Righe',
            'Totale',
          ]}
          intestazioni={INTESTAZIONI}
          pastiglie={PASTIGLIE}
          idSelezionato={aperto}
          onRigaSelezionata={(riga) => {
            const id = riga['Id'];
            if (typeof id === 'string') setAperto(id);
          }}
        />
      </div>

      {aperto && (
        <SchedaOrdine
          ordineId={aperto}
          onChiudi={() => setAperto(null)}
          onCambiato={() => setVersione((v) => v + 1)}
        />
      )}
    </section>
  );
}
